import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row g-4 mb-4" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "row g-4" }
const _hoisted_6 = { class: "col-lg-6 col-sm-6" }
const _hoisted_7 = { class: "col-lg-6 col-sm-6" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = { class: "row g-4 mb-4" }
const _hoisted_10 = { class: "col-lg-5" }
const _hoisted_11 = { class: "col-lg-7" }
const _hoisted_12 = { class: "row g-4 mb-4" }
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = { class: "col-lg-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_PerformancePerInvestmentChart = _resolveComponent("PerformancePerInvestmentChart")!
  const _component_PortfolioValue = _resolveComponent("PortfolioValue")!
  const _component_CryptoMarketCap = _resolveComponent("CryptoMarketCap")!
  const _component_TransactionsHistory = _resolveComponent("TransactionsHistory")!
  const _component_MarketPerformanceChart = _resolveComponent("MarketPerformanceChart")!
  const _component_PerformanceMetricsChart = _resolveComponent("PerformanceMetricsChart")!
  const _component_IndividualAssetPerformance = _resolveComponent("IndividualAssetPerformance")!
  const _component_RiskStabilityIndicatorsChart = _resolveComponent("RiskStabilityIndicatorsChart")!
  const _component_ComparativeAnalysisChart = _resolveComponent("ComparativeAnalysisChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PerformancePerInvestmentChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_PortfolioValue)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CryptoMarketCap)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_TransactionsHistory)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_MarketPerformanceChart)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_PerformanceMetricsChart)
      ])
    ]),
    _createVNode(_component_IndividualAssetPerformance),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_RiskStabilityIndicatorsChart)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_ComparativeAnalysisChart)
      ])
    ])
  ]))
}